import React from 'react'
import { ChecklistProgress, GiftTrackerProgress, SimpleCard } from 'baby-design'
import { registryChecklistPath, registryGiftTrackerPath } from 'lib/urls'
import useCurrentUser from 'shared/hooks/useCurrentUser/useCurrentUser'
import { useNavigate } from 'react-router-dom-v5-compat'
import { useRegistryChecklistCategories } from 'src/routes/(registry)/registry/checklist/components/api/hooks'
import { track, useTracking } from 'lib/analytics'
import { BABY_REGISTRY_TYPE } from 'registry/constants'
import {
  MobileActionsCardProps,
  MobileActionsProps,
} from './MobileActions.types'
import css from './MobileActions.styles.scss'

const Checklist: React.FC<MobileActionsCardProps> = ({
  currentRegistry,
  onClick,
}) => {
  let percentChecklistComplete = 0
  const { isLoading: checklistLoading, data: checklistData } =
    useRegistryChecklistCategories(!!currentRegistry && currentRegistry.id)
  const { completedCategoriesCount, totalCategoriesCount } = checklistData

  if (!checklistLoading && checklistData && totalCategoriesCount) {
    percentChecklistComplete = Math.round(
      (completedCategoriesCount / totalCategoriesCount) * 100
    )
  }

  const cardContent = currentRegistry ? (
    `${percentChecklistComplete}%`
  ) : (
    <span className={css.shimmer} />
  )

  return (
    <div className={css.RegistryViewHeader__checklist}>
      <SimpleCard
        content={cardContent}
        leftIcon={<ChecklistProgress value={percentChecklistComplete} />}
        role="link"
        title="Checklist"
        onClick={onClick}
      />
    </div>
  )
}

const GiftTracker: React.FC<MobileActionsCardProps> = ({
  currentRegistry,
  onClick,
}) => {
  const { regItemsCount, reservationCount } = currentRegistry || {}
  let percentGiftTrackerComplete = 0

  if (regItemsCount && reservationCount) {
    percentGiftTrackerComplete = Math.round(
      (reservationCount / regItemsCount) * 100
    )
  }

  const cardContent = currentRegistry ? (
    reservationCount
  ) : (
    <span className={css.shimmer} />
  )

  return (
    <div className={css.RegistryViewHeader__giftTracker}>
      <SimpleCard
        content={cardContent}
        leftIcon={<GiftTrackerProgress value={percentGiftTrackerComplete} />}
        role="link"
        title="Purchased"
        onClick={onClick}
      />
    </div>
  )
}

const MobileActions: React.FC<MobileActionsProps> = ({ currentRegistry }) => {
  const { id: registryId, ownerId: registryOwnerId } = currentRegistry || {}
  const tracker = useTracking()
  const navigate = useNavigate()
  const [currentUser] = useCurrentUser()
  const isRegistryOwner =
    currentRegistry && currentUser && currentRegistry.ownerId === currentUser.id
  const listType = currentRegistry?.type || BABY_REGISTRY_TYPE
  const shouldShowChecklist = listType === BABY_REGISTRY_TYPE

  const handleChecklistClick = () => {
    tracker.trackEvent({
      checklistType: 1,
      event: track.checklistViewed,
      eventLocation: track.EventLocation.REGISTRY,
      registryId,
      registryOwnerId,
      listType,
      isRegistryOwner,
    })
    navigate(registryChecklistPath)
  }

  const handleGiftTrackerClick = () => {
    tracker.trackEvent({
      checklistType: 1,
      event: track.giftTrackerClicked,
      eventLocation: track.EventLocation.REGISTRY,
      registryId,
      registryOwnerId,
      listType,
      isRegistryOwner,
    })
    navigate(registryGiftTrackerPath)
  }

  return (
    <div className={css.RegistryViewHeader__mobileActions}>
      {shouldShowChecklist && (
        <Checklist
          currentRegistry={currentRegistry}
          onClick={handleChecklistClick}
        />
      )}
      <GiftTracker
        currentRegistry={currentRegistry}
        onClick={handleGiftTrackerClick}
      />
    </div>
  )
}

export default MobileActions
